import styles from './Header.module.scss';
import { ReactComponent as Logo } from './logo-groupe-duval.svg';

function Header() {
	return (
		<header className={styles.wrapper}>
			<Logo className={styles.logo} />
		</header>
	);
}

export default Header;
